module.exports = __webpack_public_path__ + "static/sophie-70b546739b6a86cf4dd8cb7efdc5fab5.jpg";